import getStore from '@ve/services/getStore/getStore';
import TourProductFactory from '@/js/common/Domain/Factory/TourProduct';
import { clone } from 'underscore';
import { operatorRepositoryName } from '@entities/operator';
import { RoomsRepositoryName } from '@entities/room';
import { tourProductsRepositoryName } from '@entities/tourProduct';
import { countriesRepositoryName } from '@entities/country';
import getTourFirstPaymentDefinitionService from '@/js/common/Domain/Service/getTourFirstPaymentDefinition';
import countryConditions from '@ve/components/countryConditions/common/store/countryConditions';
import OperatorsRepository from '@/js/common/Domain/Repository/Operators';
import apiToursToTourProducts from '@/js/common/Domain/Service/search/apiToursToTourProducts';

import { productCompareKey, rawProductCompareKey } from '@/js/common/Domain/Service/search/getTourProductCompareKeys';
import populateRoomDescriptions from './populateRoomDescriptions';

export default function updateData(data) {
    const operatorsRepository = OperatorsRepository.repository;

    const {
        searchData,
        tourCriteria,
        tourProductsRepository,
    } = data;

    const {
        countries,
        tours,
        legs,
        routes,
        tariffs,
        rooms = [],
        operators = [],
        airlines,
        firstPaymentDefinitions = [],
    } = searchData;

    operatorsRepository.add(operators);
    getStore().commit(`${operatorRepositoryName}/setOperators`, operators?.map((operator) => Object.freeze(operator)));
    getStore().commit(`${RoomsRepositoryName}/setRooms`, rooms?.map((room) => Object.freeze(room)));
    getStore().commit(`${tourProductsRepositoryName}/setTourProducts`, tours?.map((tour) => clone(tour)).map((tour) => Object.freeze(tour)));
    getStore().commit(`${countriesRepositoryName}/setCountries`, countries?.map((country) => Object.freeze(country)));
    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.time('builTourProducts');
    }

    const toursWithRoomDescriptions = populateRoomDescriptions({
        tours,
        rooms,
    });

    const populatedTourProducts = apiToursToTourProducts({
        tours: toursWithRoomDescriptions,
        firstPaymentDefinitions,
        routes,
        tariffs,
        legs,
        airlines,
    });

    const country = tourCriteria ? tourCriteria.get('countries').at(0) : false;

    const currentTourProductsIndex = tourProductsRepository
        .getOnlyTourProducts()
        .map(productCompareKey);

    const resorts = country ? country.get('resorts') : false;
    let newTourProductModels = [];

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.log('TourProducts from request:', populatedTourProducts?.length || 0);
    }

    if (countries) {
        countryConditions.update(countries);
    }

    if (populatedTourProducts) {
        newTourProductModels = _.reduce(populatedTourProducts, (newTourProducts, tourProduct) => {
            const rawProductKey = rawProductCompareKey(tourProduct.tour);
            if (!~_.indexOf(currentTourProductsIndex, rawProductKey)) {
                const firstPaymentDefinition = getTourFirstPaymentDefinitionService(tourProduct);
                const allFirstPaymentDefinitions = tourProduct?.firstPaymentDefinitions || [];

                newTourProducts.push(new TourProductFactory({
                    ...tourProduct,
                    firstPaymentDefinition,
                    allFirstPaymentDefinitions,
                }, resorts));
            }

            return newTourProducts;
        }, []);

        tourProductsRepository.add(newTourProductModels, {
            merge: true,
        });
    }

    if (typeof console !== 'undefined' && typeof console.log === 'function') {
        console.timeEnd('builTourProducts');
        console.log('Added new tourProducts:', newTourProductModels.length);
    }

    return newTourProductModels;
}
